import React from 'react';
import { MessageCircle } from 'lucide-react';
import { mockData } from '../mock';

export const FloatingWhatsApp = () => {
  return (
    <a
      href={mockData.contact.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 animate-bounce"
      style={{ animationDuration: '3s' }}
    >
      <MessageCircle size={28} />
    </a>
  );
};
